export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_PLANNING_EVENT_CONDITION = [
  {
    attribute_key: 'event_status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: null,
    custom_attribute_type: '',
  },
];

export const PLANNING_EVENT_STAGE_VALUES = [
  { id: 'draft', name: 'Draft', i18nKey: 'DRAFT' },
  { id: 'inquiry', name: 'Inquiry', i18nKey: 'INQUIRY' },
  { id: 'confirmed', name: 'Confirmed', i18nKey: 'CONFIRMED' },
  { id: 'completed', name: 'Completed', i18nKey: 'COMPLETED' },
  { id: 'archived', name: 'Archived', i18nKey: 'ARCHIVED' },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Outgoing',
    i18nKey: 'OUTGOING',
  },
];

export const MESSAGE_IMAGE_TYPE_VALUES = [
  { id: 'ig_story_reply', i18nKey: 'IG_STORY_REPLY' },
  { id: 'story_mention', i18nKey: 'STORY_MENTION' },
  { id: 'ig_story', i18nKey: 'IG_STORY' },
  { id: 'ig_post', i18nKey: 'IG_POST' },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'None',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Low',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Medium',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'High',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgent',
    i18nKey: 'URGENT',
  },
];

export const EVENT_SOURCE_CONDITION_VALUES = [
  {
    id: 'form',
    name: 'Form',
    i18nKey: 'FORM',
  },
  {
    id: 'booking_widget',
    name: 'Booking widget',
    i18nKey: 'BOOKING_WIDGET',
  },
];
